import React from 'react';
import { cn } from '../../lib/utils';

/**
 * TableSkeleton — esqueleto de tabla animado para estados de carga.
 *
 * Props:
 *   rows    — número de filas simuladas (por defecto 7)
 *   cols    — número de columnas (por defecto 5)
 *   className — clases adicionales al contenedor
 */
const TableSkeleton = ({ rows = 7, cols = 5, className }) => {
  const colWidths = ['w-24', 'w-32', 'w-40', 'w-28', 'w-20', 'w-36', 'w-16'];

  return (
    <div className={cn('animate-pulse', className)}>
      {/* Header skeleton */}
      <div className="flex items-center gap-4 px-4 py-3 border-b border-slate-800 bg-slate-800/60">
        {Array.from({ length: cols }).map((_, i) => (
          <div
            key={i}
            className={cn('h-3 rounded-full bg-slate-700', colWidths[i % colWidths.length])}
          />
        ))}
      </div>

      {/* Rows skeleton */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={rowIdx}
          className="flex items-center gap-4 px-4 py-3.5 border-b border-slate-800/60"
          style={{ opacity: 1 - rowIdx * 0.1 }}
        >
          {Array.from({ length: cols }).map((_, colIdx) => (
            <div
              key={colIdx}
              className={cn(
                'h-3 rounded-full bg-slate-800',
                colWidths[(colIdx + rowIdx) % colWidths.length]
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
